/**
 * Contains data queried from api for the fields, used for caching
 */
import Tag from "@/shared/data/tag";

export class ArticleRecordingFieldData {
  /** Available {@link Tag}s to select from */
  tags: Tag[] = [];
}
